import { Box, Typography } from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

const TitleHeaders = ({ title, subtitle, isRequired }) => {
  return (
    <Box sx={{ marginBottom: "20px" }}>
      <Typography variant="h5">
        <ArrowRightIcon sx={{ fill: "#00BBEE" }} />
        {title}
        {isRequired ? "*" : ""}
      </Typography>
      {subtitle && (
        <Typography
          variant="subtitle1"
          sx={{ marginLeft: ["5px","30px"], marginTop: "5px" }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default TitleHeaders;
